module.exports = __webpack_public_path__ + "img/foot.7d24dd73.png";